import { textStyleCss } from 'src/theme/atlas';
import styled, { css } from 'styled-components';

export const AccordionSubtitleStyled = styled.div<{
  showError?: boolean;
  $statusBadgeRow?: boolean;
}>`
  display: flex;
  column-gap: 10px;
  align-items: center;
  overflow-x: hidden;
  max-width: ${(props) => (props.showError ? '455px' : '300px')};
  ${(props) =>
    props.$statusBadgeRow &&
    css`
      max-width: unset;
      width: 380px;
    `}
`;

export const AccordionSubtitleBadgeWrap = styled.span`
  flex-shrink: 0;
`;

export const AccordionDate = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const AccordionAuthor = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  font-weight: 600;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  min-width: 0;
  flex: 1 1 0;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
